import { render, staticRenderFns } from "./FieldType20.vue?vue&type=template&id=0e5b1cdc&scoped=true"
import script from "./FieldType20.vue?vue&type=script&lang=js"
export * from "./FieldType20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5b1cdc",
  null
  
)

export default component.exports